/* =========================================
   JAIMCHO — Theme JS v8
   ========================================= */

/* ─────────────────────────────────────────
   RANDOM LOGO — tirage au sort au chargement
   Utilise window._logoSrcs injecté par header.liquid
   ───────────────────────────────────────── */
(function() {
  var srcs = window._logoSrcs;
  if (!srcs || srcs.length < 2) return;
  var chosen = srcs[Math.floor(Math.random() * srcs.length)];
  document.querySelectorAll('.header-logo-img, .splash-logo-img').forEach(function(img) {
    img.src = chosen;
  });
})();

(function () {
  'use strict';

  /* =========================================
     CART DRAWER
     ========================================= */

  const cartToggle  = document.getElementById('cart-toggle');
  const cartClose   = document.getElementById('cart-close');
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartBody    = document.getElementById('cart-body');
  const cartCount   = document.getElementById('cart-count') || document.getElementById('nav-cart-count');
  const cartTotal   = document.getElementById('cart-total');
  const cartCheckoutWrap = document.getElementById('cart-checkout-wrap');

  function openCart()  {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    document.body.classList.add('cart-open');
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    document.body.classList.remove('cart-open');
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 2
    });
  }

  function updateCartCount(n) {
    if (!cartCount) return;
    if (n > 0) { cartCount.textContent = '(' + n + ')'; cartCount.style.display = 'inline'; }
    else cartCount.style.display = 'none';
  }

  function renderCart(cart) {
    if (!cartBody) return;
    if (!cart.item_count) {
      cartBody.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
      if (cartCheckoutWrap) cartCheckoutWrap.style.display = 'none';
      updateCartCount(0);
      return;
    }
    updateCartCount(cart.item_count);
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
    if (cartCheckoutWrap) cartCheckoutWrap.style.display = 'block';

    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : '<div class="cart-item__image-placeholder"></div>'}
        </div>
        <div class="cart-item__details">
          <p class="cart-item__title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <div class="cart-item__bottom">
            <div class="cart-item__qty">
              <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
              <span class="qty-value">${item.quantity}</span>
              <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
            </div>
            <p class="cart-item__price">${formatMoney(item.line_price)}</p>
          </div>
        </div>
      </div>
    `).join('');

    cartBody.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const qty = parseInt(btn.dataset.qty, 10);
        const newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        updateCartItem(btn.dataset.key, newQty);
      });
    });
  }

  function fetchCart() {
    fetch('/cart.js').then(r => r.json()).then(renderCart).catch(console.warn);
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(r => r.json()).then(renderCart).catch(console.warn);
  }

  function interceptAddToCart() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(r => r.ok ? r.json() : r.json().then(err => Promise.reject(err)))
          .then(() => { fetchCart(); openCart(); })
          .catch(err => alert(err.description || 'Could not add item to cart.'))
          .finally(() => { if (btn) { btn.disabled = false; btn.textContent = 'AJOUTER AU PANIER'; } });
      });
    });
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  fetchCart();

  /* =========================================
     NAV OVERLAY — menu plein écran
     ========================================= */

  const menuToggle      = document.getElementById('menu-toggle');
  const menuClose       = document.getElementById('menu-close');
  const navOverlay      = document.getElementById('nav-overlay');
  const navSearchTrigger = document.getElementById('nav-search-trigger');
  const navCartTrigger  = document.getElementById('nav-cart-trigger');
  const navSearchForm   = document.getElementById('nav-search-form');
  const navSearchInput  = document.getElementById('nav-search-input');

  function openMenu() {
    if (!navOverlay) return;
    navOverlay.classList.add('is-open');
    navOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!navOverlay) return;
    navOverlay.classList.remove('is-open');
    navOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-is-open');
    document.body.style.overflow = '';
    if (navSearchForm) navSearchForm.classList.remove('is-open');
    if (navSearchInput) navSearchInput.value = '';
    // Remettre le bouton "Search" visible
    if (navSearchTrigger) navSearchTrigger.style.display = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', function() {
    /* Si le panier est ouvert, le "−" ferme le panier */
    if (document.body.classList.contains('cart-open')) {
      closeCart();
    } else {
      closeMenu();
    }
  });

  /* Clic en dehors des liens/formulaire → ferme le menu */
  if (navOverlay) {
    navOverlay.addEventListener('click', e => {
      if (!e.target.closest('a, button, input, form')) {
        closeMenu();
      }
    });
  }

  if (navSearchTrigger) {
    navSearchTrigger.addEventListener('click', () => {
      if (!navSearchForm) return;
      // Cacher le bouton "Search", afficher le formulaire à sa place
      navSearchTrigger.style.display = 'none';
      navSearchForm.classList.add('is-open');
      if (navSearchInput) navSearchInput.focus();
    });
  }

  if (navCartTrigger) {
    navCartTrigger.addEventListener('click', () => {
      closeMenu();
      openCart();
    });
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMenu();
  });

  /* =========================================
     PRODUCT GRID
     ========================================= */

  const grid = document.getElementById('product-grid');

  function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function getProductUrls() {
    return grid ? (grid.dataset.productUrls || '').split('|').filter(Boolean) : [];
  }

  function placeItems(productItems, editorialItems, randomise) {
    let products = randomise ? shuffle([...productItems]) : [...productItems];
    const positioned = editorialItems.filter(e => parseInt(e.dataset.position, 10) > 0);
    const floating   = editorialItems.filter(e => parseInt(e.dataset.position, 10) <= 0);
    let result = [...products];

    if (randomise) {
      floating.forEach(item => result.splice(Math.floor(Math.random() * (result.length + 1)), 0, item));
    } else {
      const step = Math.max(1, Math.floor(result.length / (floating.length + 1)));
      floating.forEach((item, i) => result.splice(Math.min((i + 1) * step, result.length), 0, item));
    }

    positioned.forEach(item => {
      const pos = Math.min(Math.max(parseInt(item.dataset.position, 10) - 1, 0), result.length);
      result.splice(pos, 0, item);
    });

    result.forEach((item, i) => {
      grid.appendChild(item);
      if (randomise) {
        item.classList.remove('is-shuffling');
        setTimeout(() => item.classList.add('is-shuffling'), i * 16);
      }
    });
  }

  function initGrid() {
    if (!grid) return;
    const productItems   = Array.from(grid.querySelectorAll('.grid-item--product'));
    const editorialItems = Array.from(grid.querySelectorAll('.grid-item--editorial'));
    placeItems(productItems, editorialItems, false);

    editorialItems.forEach(item => {
      item.addEventListener('click', () => {
        const link = item.dataset.link;
        if (link) {
          window.location.href = link;
        } else {
          const urls = getProductUrls();
          if (urls.length) window.location.href = urls[Math.floor(Math.random() * urls.length)];
        }
      });
    });
  }

  function shuffleGrid() {
    if (!grid) return;
    const productItems   = Array.from(grid.querySelectorAll('.grid-item--product'));
    const editorialItems = Array.from(grid.querySelectorAll('.grid-item--editorial'));
    placeItems(productItems, editorialItems, true);
  }

  /* =========================================
     SPLASH
     ========================================= */

  const splash   = document.getElementById('splash');
  const splashBtn = document.getElementById('splash-enter');
  const header   = document.getElementById('site-header');
  const logoLink = document.getElementById('header-logo-link');
  const isHomepage = window.isHomepage === true;

  var inDesignMode = window.Shopify && window.Shopify.designMode;

  function enterStore() {
    if (splash) splash.classList.add('is-hidden');
    if (header) header.classList.add('is-visible');
    if (!inDesignMode) {
      try { sessionStorage.setItem('sosei_entered', '1'); } catch (_) {}
    }
  }

  function alreadyEntered() {
    if (inDesignMode) return false; // toujours montrer le splash dans le customizer
    try { return sessionStorage.getItem('sosei_entered') === '1'; } catch (_) { return false; }
  }

  if (isHomepage && logoLink) {
    logoLink.addEventListener('click', e => { e.preventDefault(); shuffleGrid(); });
  }

  /* ---- DVD bounce ---- */
  var dvdRaf = null;

  function randomDVDFilter() {
    var hue = Math.floor(Math.random() * 360);
    return 'invert(1) sepia(1) saturate(5) hue-rotate(' + hue + 'deg)';
  }

  function initDVDBounce() {
    if (!splash || !splashBtn) return;

    // Remove CSS transform centering — JS takes over
    splashBtn.style.transform = 'none';
    // Couleur initiale aléatoire
    splashBtn.style.filter = randomDVDFilter();

    var w = splashBtn.offsetWidth  || 110;
    var h = splashBtn.offsetHeight || 70;

    // Start near center
    var x  = (splash.offsetWidth  - w) / 2;
    var y  = (splash.offsetHeight - h) / 2;
    // Random direction, normalized speed ~2px/frame
    var angle = Math.random() * 2 * Math.PI;
    var speed = 2;
    var dx = Math.cos(angle) * speed;
    var dy = Math.sin(angle) * speed;

    function step() {
      var maxX = splash.offsetWidth  - splashBtn.offsetWidth;
      var maxY = splash.offsetHeight - splashBtn.offsetHeight;

      x += dx;
      y += dy;

      var bounced = false;
      if (x <= 0)    { x = 0;    dx =  Math.abs(dx); bounced = true; }
      if (x >= maxX) { x = maxX; dx = -Math.abs(dx); bounced = true; }
      if (y <= 0)    { y = 0;    dy =  Math.abs(dy); bounced = true; }
      if (y >= maxY) { y = maxY; dy = -Math.abs(dy); bounced = true; }

      // Changer de couleur à chaque rebond sur un mur
      if (bounced) splashBtn.style.filter = randomDVDFilter();

      splashBtn.style.left = x + 'px';
      splashBtn.style.top  = y + 'px';

      dvdRaf = requestAnimationFrame(step);
    }

    dvdRaf = requestAnimationFrame(step);
  }

  function stopDVD() {
    if (dvdRaf) { cancelAnimationFrame(dvdRaf); dvdRaf = null; }
  }

  /* ─────────────────────────────────────────────────────
     CRACK EFFECT — clic à côté du logo = fissure
     Lignes longues traversant l'écran, base gris/blanc,
     petites touches de couleur animées lentement
     ───────────────────────────────────────────────────── */
  function initCrackEffect() {
    if (!splash) return;
    var canvas = document.createElement('canvas');
    canvas.id = 'crack-canvas';
    canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:5;';
    splash.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var cracks = [];
    var hueBase = 0;
    var rafId = null;

    function resize() {
      canvas.width  = splash.offsetWidth  || window.innerWidth;
      canvas.height = splash.offsetHeight || window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    /* Bras long qui traverse l'écran — courbe très légère, 0-1 branche courte */
    function makeLongArm(startX, startY, angle) {
      var segs = [];
      var cx = startX, cy = startY;
      var a = angle;
      var step = 12;
      var w = canvas.width, h = canvas.height;

      for (var iter = 0; iter < 400; iter++) {
        a += (Math.random() - 0.5) * 0.035; /* légère dérive */
        var nx = cx + Math.cos(a) * step;
        var ny = cy + Math.sin(a) * step;
        segs.push({ x1: cx, y1: cy, x2: nx, y2: ny });
        cx = nx; cy = ny;
        if (cx < -20 || cx > w + 20 || cy < -20 || cy > h + 20) break;
      }

      /* 0 ou 1 branche courte */
      if (segs.length > 4 && Math.random() < 0.55) {
        var bi = Math.floor(segs.length * (0.25 + Math.random() * 0.45));
        var bx = segs[bi].x2, by = segs[bi].y2;
        var ba = a + (Math.random() > 0.5 ? 1 : -1) * (0.25 + Math.random() * 0.4);
        var bLen = 50 + Math.random() * 80;
        for (var j = 0; j < bLen / step; j++) {
          ba += (Math.random() - 0.5) * 0.05;
          var bnx = bx + Math.cos(ba) * step;
          var bny = by + Math.sin(ba) * step;
          segs.push({ x1: bx, y1: by, x2: bnx, y2: bny });
          bx = bnx; by = bny;
          if (bx < -20 || bx > w + 20 || by < -20 || by > h + 20) break;
        }
      }
      return segs;
    }

    /* 3-4 bras longs depuis le point de clic */
    function makeCrack(x, y) {
      var numArms = 3 + Math.floor(Math.random() * 2);
      var segs = [];
      for (var i = 0; i < numArms; i++) {
        var angle = (Math.PI * 2 / numArms) * i + (Math.random() - 0.5) * 0.35;
        segs = segs.concat(makeLongArm(x, y, angle));
      }
      return { segs: segs };
    }

    /* Rendu — base blanche/grise, touches de couleur lentes et subtiles */
    function render() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      hueBase = (hueBase + 0.12) % 360; /* défilement couleur très lent */

      for (var c = 0; c < cracks.length; c++) {
        var crack = cracks[c];
        for (var s = 0; s < crack.segs.length; s++) {
          var seg = crack.segs[s];

          /* Coordonnées pixel-perfect pour éviter le flou sub-pixel */
          var x1 = Math.round(seg.x1) + 0.5;
          var y1 = Math.round(seg.y1) + 0.5;
          var x2 = Math.round(seg.x2) + 0.5;
          var y2 = Math.round(seg.y2) + 0.5;

          /* Trait principal — blanc/gris très net */
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.lineWidth = 0.85;
          ctx.strokeStyle = 'rgba(220,220,220,0.88)';
          ctx.stroke();

          /* Touche de couleur iridescente — un segment sur 4, saturation faible */
          if (s % 4 === (c % 4)) {
            var hue = (hueBase + c * 55 + s * 7) % 360;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.lineWidth = 0.65;
            ctx.strokeStyle = 'hsla(' + hue + ',55%,80%,0.4)';
            ctx.stroke();
          }
        }
      }
      rafId = requestAnimationFrame(render);
    }

    /* Écoute les clics sur le splash — ignore le logo */
    splash.addEventListener('click', function(e) {
      if (splashBtn && (e.target === splashBtn || splashBtn.contains(e.target))) return;
      var rect = canvas.getBoundingClientRect();
      cracks.push(makeCrack(e.clientX - rect.left, e.clientY - rect.top));
      if (!rafId) render();
    });

    /* Stoppe l'animation quand le splash disparaît */
    var mo = new MutationObserver(function() {
      if (splash.style.display === 'none' || !splash.offsetParent) {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      }
    });
    mo.observe(splash, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  if (isHomepage) {
    if (splashBtn) splashBtn.addEventListener('click', function() { stopDVD(); enterStore(); });
    else if (splash) splash.addEventListener('click', function() { stopDVD(); enterStore(); });
    if (alreadyEntered()) {
      stopDVD();
      enterStore();
    } else {
      initDVDBounce();
      initCrackEffect();
    }
  }

  /* =========================================
     SIZE SELECTOR — couleur aléatoire + mise à jour variant
     Utilise 'click' sur le label (plus fiable que 'change' sur radio caché)
     ========================================= */

  function initSizeSelector() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var labels   = form.querySelectorAll('.product-size-label');
    var idInput  = form.querySelector('input[name="id"]');
    var variants = window.productVariants || [];
    var priceEl  = document.querySelector('.product-price');

    /* Formate un prix en centimes → string lisible (ex: 18000 → "180,00 €") */
    function fmtPrice(cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    }

    if (!labels.length || !idInput) return;

    var dvdColors = ['#FF0000','#FF7700','#00CC00','#0066FF','#9900CC','#FF0099','#00BBBB','#FF4400'];
    var lastColorIdx = -1;

    /* Si tous les variants sont épuisés, forcer l'affichage du prix du 1er variant */
    var allSoldOut = labels.length > 0 && Array.prototype.every.call(labels, function(l) {
      var r = l.querySelector('input[type="radio"]');
      return r && r.disabled;
    });
    if (allSoldOut && priceEl && variants.length > 0) {
      var firstPrice = variants[0].price;
      if (firstPrice != null && firstPrice > 0) {
        priceEl.textContent = fmtPrice(firstPrice);
        priceEl.style.display = '';
      }
    }

    labels.forEach(function(label) {
      label.addEventListener('click', function() {
        var radio = label.querySelector('input[type="radio"]');
        if (!radio || radio.disabled) return;

        // Réinitialiser toutes les tailles
        labels.forEach(function(l) {
          l.classList.remove('is-selected');
          var s = l.querySelector('.product-size-value');
          if (s) s.style.removeProperty('color');
        });

        // Couleur aléatoire (différente de la précédente) sur le span
        var idx;
        do { idx = Math.floor(Math.random() * dvdColors.length); } while (idx === lastColorIdx && dvdColors.length > 1);
        lastColorIdx = idx;

        label.classList.add('is-selected');
        var span = label.querySelector('.product-size-value');
        if (span) span.style.color = dvdColors[idx];

        // Mettre à jour l'ID de variant après que le navigateur a coché le radio
        setTimeout(function() {
          var selectedVal = radio.value;

          // Chercher le variant qui contient cette valeur d'option
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].options.indexOf(selectedVal) !== -1) {
              match = variants[i];
              break;
            }
          }

          if (match) {
            idInput.value = match.id;
            /* Met à jour le prix avec celui du variant sélectionné */
            if (priceEl && match.price != null) {
              priceEl.textContent = fmtPrice(match.price);
              priceEl.style.display = '';
            }
            var btn = form.querySelector('.btn-add-to-cart');
            if (btn) {
              btn.disabled = !match.available;
              btn.textContent = match.available ? 'AJOUTER AU PANIER' : 'INDISPONIBLE';
            }
          }
        }, 0);
      });
    });
  }

  initGrid();
  interceptAddToCart();
  initSizeSelector();

  /* =========================================
     PHOTO PAGE — horizontal scroll + progress
     ========================================= */

  const photoScroll = document.getElementById('photo-scroll');
  const progressBar = document.getElementById('photo-progress-bar');

  if (photoScroll) {
    // Progress bar
    photoScroll.addEventListener('scroll', () => {
      const max = photoScroll.scrollWidth - photoScroll.clientWidth;
      if (progressBar) progressBar.style.width = (max > 0 ? (photoScroll.scrollLeft / max) * 100 : 0) + '%';
    }, { passive: true });

    // Drag to scroll
    let isDown = false, startX, scrollLeft;

    photoScroll.addEventListener('mousedown', e => {
      isDown = true;
      photoScroll.classList.add('is-dragging');
      startX = e.pageX - photoScroll.offsetLeft;
      scrollLeft = photoScroll.scrollLeft;
    });

    document.addEventListener('mouseup', () => {
      isDown = false;
      if (photoScroll) photoScroll.classList.remove('is-dragging');
    });

    photoScroll.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      photoScroll.scrollLeft = scrollLeft - (e.pageX - photoScroll.offsetLeft - startX);
    });

  }

  /* =========================================
     NATIVE VIDEO CONTROLS
     ========================================= */

  function initVideoControls() {
    document.querySelectorAll('.photo-block--video').forEach(function(block) {
      var video = block.querySelector('video.photo-video');
      if (!video) return; // skip iframes

      // Build controls HTML
      var ctrl = document.createElement('div');
      ctrl.className = 'video-controls';
      ctrl.innerHTML =
        '<div class="video-progress" id="">' +
          '<div class="video-progress__fill"></div>' +
        '</div>' +
        '<button class="video-vol-btn" aria-label="Mute/Unmute">🔊</button>' +
        '<input type="range" class="video-vol-slider" min="0" max="1" step="0.05" value="0" aria-label="Volume">';
      block.appendChild(ctrl);

      var progressWrap = ctrl.querySelector('.video-progress');
      var progressFill = ctrl.querySelector('.video-progress__fill');
      var volBtn       = ctrl.querySelector('.video-vol-btn');
      var volSlider    = ctrl.querySelector('.video-vol-slider');

      // Video starts muted (autoplay requirement); reflect in slider
      video.muted  = true;
      volSlider.value = 0;

      // Update progress fill as video plays
      video.addEventListener('timeupdate', function() {
        if (video.duration) {
          progressFill.style.width = (video.currentTime / video.duration * 100) + '%';
        }
      });

      // Seek on click
      progressWrap.addEventListener('click', function(e) {
        var rect = progressWrap.getBoundingClientRect();
        var pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        if (video.duration) video.currentTime = pct * video.duration;
      });

      // Volume slider
      volSlider.addEventListener('input', function() {
        var v = parseFloat(volSlider.value);
        video.volume = v;
        video.muted  = (v === 0);
        volBtn.textContent = video.muted ? '🔇' : '🔊';
      });

      // Mute toggle button
      volBtn.addEventListener('click', function() {
        video.muted = !video.muted;
        if (video.muted) {
          volBtn.textContent = '🔇';
          volSlider.value = 0;
        } else {
          video.volume = video.volume || 0.8;
          volBtn.textContent = '🔊';
          volSlider.value = video.volume;
        }
      });
    });
  }

  initVideoControls();

})();
